import classes from './VODPlayer.module.scss';

export function PlayerSkeleton() {
  return (
    <div className={classes.vod}>
      <div className={classes.video}>
        <div className={classes.playerSkeleton} />
      </div>
      <div className={classes.foo}>
        <div className={classes.chat}>
          <div className={classes.chatLoading}>Chat wird geladen...</div>
        </div>
      </div>
    </div>
  );
}
